import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const Layout = styled.div`
    display: block;
    background-color: ${Variables.Colors.sidebarBackground};
    padding: 48px;
`;
